import React from 'react';

import * as S from './styles';
import WaitingForDataDynamicPage from 'components/WaitingForDataDynamicPage';
import { ItemDynamicPageInPhone } from 'types/ItemDynamicPageInPhone';
import { DataInputsFocusTextProps } from 'components/FormDynamicPageSelected/Forms/InputsFocusText';
import ScheduleInfoDynamicPage from 'components/ScheduleInfoDynamicPage';

interface FocusTextProps {
	item: ItemDynamicPageInPhone;
}

//esse módulo é igual em todos os tipos de loja
export default function FocusText({ item }: FocusTextProps) {
	const { data } = item;

	const itemText: DataInputsFocusTextProps = data;

	function returnSize(size: string, isTitle: boolean) {
		let fontsize = 10;

		switch (size) {
			case 'small':
				fontsize = 10;
				break;

			case 'regular':
				fontsize = 12;
				break;

			case 'big':
				fontsize = 14;
				break;

			default:
				break;
		}

		return isTitle ? fontsize + 2 : fontsize;
	}

	function returnCentralize(orientation: string) {
		let centralize = 'center';

		switch (orientation) {
			case 'center':
				centralize = 'center';
				break;

			case 'left':
				centralize = 'flex-start';
				break;

			case 'right':
				centralize = 'flex-end';
				break;

			default:
				break;
		}

		return centralize;
	}

	return Object.keys(item.data).length === 0 ? (
		<WaitingForDataDynamicPage />
	) : (
		<S.container>
			{(itemText.schedule_start !== '' || itemText.schedule_end !== '') && (
				<ScheduleInfoDynamicPage
					countdown={itemText.countdown}
					endDate={itemText.schedule_end}
					startDate={itemText.schedule_start}
				/>
			)}
			<S.boxInfo $alignText={returnCentralize(itemText.centralizeText)}>
				<S.title
					$size={returnSize(itemText.sizeName, true)}
					$weight={itemText.nameWeight}
				>
					{itemText.name}
				</S.title>

				<S.subTitle
					$size={returnSize(itemText.sizeName, false)}
					$weight={itemText.descriptionWeight}
				>
					{itemText.description}
				</S.subTitle>
			</S.boxInfo>
		</S.container>
	);
}
